/* eslint-disable import/no-namespace */
import _ from 'lodash'
import * as types from '../../actions'
import isEmpty from '../../../utils/isEmpty'
import {  sponsors } from "../../../utils/constants"

const resetdirector = { 
	directorname:'',
	eventemail:'',
	directorssoemail:'',
	directorphone:'',
	directorcountry:'',
	directoraddress1:'',
	directoraddress2:'',
	directorcity:'',
	directorstate:'',
	directorzipcode:''
}       
const resetevent = {
    eventaddress:'',
    centercertnumber:'',
    centername:'',
    eventcity:'',
    eventstate:'',
    eventzipcode:'',
    eventcountry: 'usa'
}
function addParticipant(school, eventgendermen,eventgenderwomen , participantschools) 
{
	const { hasMenTeam,hasWomenTeam,menNonMember, menTeamUSBCId,name,schoolId,womenNonMember,womenTeamUSBCId } = school

	const exists = _.find(participantschools,['schoolId',schoolId])

	if (exists === undefined) {

		const menteam = (hasMenTeam || menNonMember) && eventgendermen
		const womenteam = (hasWomenTeam || womenNonMember) && eventgenderwomen
	
		const participant = {
			'schoolId':schoolId,
			'menteam':menteam,
			'womenteam':womenteam,
			'name':name,
			'womennonmember':womenNonMember,
			'mennonmember':menNonMember,
			'haswomenteam':hasWomenTeam,
			'hasmenteam':hasMenTeam,
			'womenTeamUSBCId':womenTeamUSBCId,
			'menTeamUSBCId': menTeamUSBCId
		}  
		participantschools.unshift(participant)
	}
	return participantschools

}
function removeSchool(schoolindex, values){
  const { participantschools } = values
  const participants = participantschools.filter((item,index) => index != schoolindex)
  return  Object.assign({}, values, { participantschools:participants })
}
function sortParticipants(sortorder, values) {
  let participants
  const { participantschools, sorted } = values
  const sortdone = !sorted
    
  if (sortorder === types.SORT_ASCENDING) {
      participants = participantschools.sort((a,b) =>   a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
  } else if (sortorder === types.SORT_DESCENDING) {
      participants = participantschools.sort((a,b) =>  b.name.toLowerCase().localeCompare(a.name.toLowerCase()))  
	}
	
  return  Object.assign({}, values, { participantschools:participants, sorted:sortdone })
}
function setEventDetails(details ) {
	const eventdetails = {
		isEventDetailsVerified:details.isEventDetailsVerified,
		eventgendermen:details.male,
		eventgenderwomen:details.female,
		eventtier:details.tier.toString(),
		eventsponsor:details.eventSponsor.toString(),
		eventjvgendermen:details.jvMale,
		eventjvgenderwomen:details.jvFemale,
		eventjv: (details.jvMale || details.jvFemale).toString(),
		eventsamequalifyingformat:details.hasSameQualifyingFormat != null ? details.hasSameQualifyingFormat.toString():"true"
	}			
	return eventdetails
}
function setEventSetup(setup) {
	const { numberOfStandardGames, numberOfBakerGames } = setup
	const notSpecifiedYet = (numberOfStandardGames == 0 && numberOfBakerGames == 0) ? true:false
	const eventSetup = {
		standardgames:notSpecifiedYet ? undefined: numberOfStandardGames,
		bakergames:notSpecifiedYet ? undefined:numberOfBakerGames,
		hasbrackets:setup.hasBrackets
	}
	return eventSetup
}
// when creating an event we need to make sure the season has been setup.
function getEventEligibleSeasons(seasons){
      return _.filter(seasons, { isSeasonSet:true })
} 
function getEventSeasonSettings(seasonId, eventSeasons){
  const settings = _.find(eventSeasons,{ 'id':seasonId })
  const { 
		firstSemesterStartDate,rollOverDate, minT1games, minT2games,maxEventDuration,templateReleaseDays,
		bakerToStandardGamesRatio,minWomenTeams, minMenTeams, 
		oilSportTo, oilChallengeFrom, oilChallengeTo, oilStandardFrom,oilStandardTo, year
	} = settings
  return {
		firstSemesterStartDate,
		rollOverDate, 
		minT1games, 
		minT2games,
		maxEventDuration,
		templateReleaseDays,
		bakerToStandardGamesRatio,
		minWomenTeams,
		minMenTeams, 
		oilSportTo, 
		oilChallengeFrom, 
		oilChallengeTo, 
		oilStandardFrom,
		oilStandardTo,
    year
  }

}
function isOilRatioByGender(day1Men,day1Women,day2Men,day2Women,day3Men,day3Women){
   const isDay1Different = day1Men != day1Women 
   const isDay2Different = day2Men != day2Women 
   const isDay3Different = day3Men != day3Women 
   return  ((isDay1Different == true) ||  (isDay2Different == true) ||  (isDay3Different == true) ? "true":"false")
}
function isDailyOilMen(day1Men,day2Men,day3Men){
  if(isEmpty(day2Men) && isEmpty(day3Men)){
     return "false"
  }
  return  ((day1Men != day2Men != day3Men ) ? "true":"false")
}
function isDailyOilWomen(day1Women,day2Women,day3Women){
  if(isEmpty(day2Women) && isEmpty(day3Women)){
    return "false"
  }
  return  ((day1Women != day2Women != day3Women ) ? "true":"false")
}
function generateOilRatios(laneconditions){
  
  const { oilRatio } = laneconditions

  const day1Men= oilRatio[0] != undefined ?  oilRatio[0].men:''
  const day1Women= oilRatio[0] != undefined ?  oilRatio[0].women:''
  const day2Men= oilRatio[1] != undefined ?  oilRatio[1].men:''
  const day2Women= oilRatio[1] != undefined ?  oilRatio[1].women:''
  const day3Men= oilRatio[2] != undefined ?  oilRatio[2].men:''
  const day3Women= oilRatio[2] != undefined ?  oilRatio[2].women:''
  
  const isoilratiobygender  = isOilRatioByGender(day1Men,day1Women,day2Men,day2Women,day3Men,day3Women)
  const dailyoilratioswomen = isDailyOilWomen(day1Women,day2Women,day3Women)
  const dailyoilratiosmen   = isDailyOilMen(day1Men,day2Men,day3Men)
  const dailyoilratios      = (dailyoilratioswomen == "true" || dailyoilratiosmen == "true") ? "true":"false"

  return {
    isoilratiobygender,
    dailyoilratios,
    dailyoilratioswomen,
    dailyoilratiosmen,
    oilratio:{
            1:{
              men:day1Men,
              women:day1Women,
              single:day1Men
            },
            2:{
              men:day2Men,
              women:day2Women,
              single:day2Men
            },
            3:{
              men:day3Men,
              women:day3Women,
              single:day3Men
            }  
    }
  }
}
function generateParticipantSchools(eventParticipants){
  
  const { participants } = eventParticipants
  const schools = participants.map(function(school) {
		const { schoolId,hasMenTeam,hasWomenTeam,schoolName,hasWomenNonMember,hasMenNonMember,
						hasJV1MenTeam, hasJV2MenTeam,hasJV1WomenTeam, hasJV2WomenTeam,schoolHasMenTeam, 
						schoolHasWomenTeam,menTeamUSBCId,womenTeamUSBCId } = school
		return { 
			schoolId:parseInt(schoolId),
			menteam:hasMenTeam,
			womenteam:hasWomenTeam,
			hasmenteam:schoolHasMenTeam,
			haswomenteam:schoolHasWomenTeam,
			name:schoolName,
			womennonmember:hasWomenNonMember,
			mennonmember:hasMenNonMember,
			menjv1team:hasJV1MenTeam,
			menjv2team:hasJV2MenTeam,
			womenjv1team:hasJV1WomenTeam,
			womenjv2team:hasJV2WomenTeam,
			menTeamUSBCId,
			womenTeamUSBCId 
		}
  })
  return schools
}

export default function eventinfo (state, action)  {
	//console.log('eventinfo ',action.type)
	switch(action.type) {
		case types.RESET_RETRIEVED_EVENT:
		{
			const response = {
				eventRetrieved:false,
				inWizardMode:true
			}
			return { 
				...state, 
				values: {
					...state.values,
					...response
				},
				fields: {
					...state.fields,
					...response
				}
			}	
		}
		case  types.COPY_EVENT:
		{
			const copiedEventId = action.payload.data
			return { ...state, 
				values: {
					...state.values,
					copiedEventId
				},
				fields: {
					...state.fields,
					copiedEventId
				}
			} 
		}
		case types.RESET_EVENT_WIZARD:
		{
			const reset = {
				participantschools:[],
				currentWizardStep:1,
				eventId:0,
				eventname:'',
				startdate:'',
				enddate:'',
				memberidprefix:'',
				memberidsuffix:'',
				bakergames:'',
				standardgames:'',
				prestineeventdetails:{},
				prestineinfo:{},
				prestineoilratio:{},
				prestinesetup:{},
				prestineparticipantschools:[],
				...resetevent,
				...resetdirector		 
			} 

			return { 
				...state, 
				values:
				{
					...state.values,
					...reset
				},
				fields: {
					...state.fields,
					...reset
				}
			}
		}
		case types.FETCHING_EVENT:
		{
			return { 
				...state, 
				values:
				{
					...state.values,
					fetchingevent:true
				},
				fields: {
					...state.fields,
					fetchingevent:true
				}
			}
		}
		case types.FETCH_EVENT:
		{            
			if(action.payload.data != undefined) {
				
				const { currentWizardStep,eventInfo, details,laneConditions,eventSetup,eventParticipants } = action.payload.data
				const  { centerAddress } = eventInfo
				const { directorAddress } = eventInfo
				const memberid =  eventInfo.directorUsbcmemberId.split('-')

				const info = {
					eventId:eventInfo.eventId,
					eventVerificationEmailSent:eventInfo.eventVerificationEmailSent,
					isEventInfoVerified:eventInfo.isEventInfoVerified,
					eventcertnumber:eventInfo.certificationNumber,
					prestineeventcertnumber:eventInfo.certificationNumber,
					eventname:eventInfo.name,
					startdate:eventInfo.startDate,
					enddate:eventInfo.endDate,
					centername:eventInfo.centerName,
					centercertnumber: eventInfo.centerCertificationNumber,
					eventaddress:centerAddress.addressLine1,
					eventcity:centerAddress.city,
					eventstate:centerAddress.state,
					eventzipcode:centerAddress.zipCode,
					eventcountry:!isEmpty(centerAddress.country) ? centerAddress.country: 'US',
					directorname:eventInfo.directorName,
					directorssoemail:eventInfo.directorSsoemail,
					directorphone:eventInfo.directorPhoneNumber,
					eventemail:eventInfo.eventEmail,
					directoraddress1:directorAddress.addressLine1,
					directorcity:directorAddress.city,
					directorstate:directorAddress.state.toUpperCase(),
					directorzipcode:directorAddress.zipCode,
					directorcountry:directorAddress.country,
					memberidprefix:memberid[0],
					memberidsuffix:memberid[1]
				}
				const eventdetails = setEventDetails(details)

				const oilratio = generateOilRatios(laneConditions)
				const participantschools = generateParticipantSchools(eventParticipants)
				const setup = setEventSetup(eventSetup)
					// get a copy of original participants and save it only if changes occur
				const prestineparticipantschools = [...participantschools]
				const prestineinfo = info
				const prestineeventdetails = eventdetails
				const prestineoilratio = oilratio
				const prestinesetup = setup				
				const eventRetrieved = true
			
				return { ...state, 
					values: {
						...state.values, 
						...info ,
						...eventdetails ,
						...oilratio,
						...setup,
						participantschools,
						prestineinfo,
						prestineeventdetails,
						prestineoilratio,
						prestinesetup,
						prestineparticipantschools,
						copiedEventId: -1,
						eventRetrieved:eventRetrieved,
						inWizardMode:false,
						currentWizardStep:currentWizardStep,
						schools:[],
						schoolNotFound:false,
						fetchingevent:false    
					},
					fields: {
						...state.fields,
						...info,
						...eventdetails,
						...oilratio,
						...setup,
						participantschools,
						prestineinfo,
						prestineeventdetails,
						prestineoilratio,
						prestinesetup,
						prestineparticipantschools,
						copiedEventId: -1,
						eventRetrieved:eventRetrieved,
						inWizardMode:false,
						currentWizardStep:currentWizardStep,
						schools:[] ,
						schoolNotFound:false ,
						fetchingevent:false       
					}
				}
			}
			return state
		}
		case types.FETCH_COMPLETED_EVENTS:
		{
			if(action.payload.data != undefined) {
				const pendinguploads = action.payload.data
				return { ...state, 
					values:
					{
						...state.values,
						pendinguploads
					},
					fields: {
						...state.fields,
						pendinguploads
					}
				}
			}
			return state
		}
		case types.FETCH_CENTER:
		{
			const recordsFound = action.payload.data ? action.payload.data.Results.length: 0

			if (recordsFound > 0)
			{
				const centers = action.payload.data

				if(recordsFound == 1)
				{
					const center = centers.Results[0]

					const address = _.zipObject(['city', 'statezip'], center.citystatezip.split(','));
						
					const statezip    = address.statezip.trim().split(' ')
					const eventstate  = statezip[0]
					const zipcode     = statezip[1]

					const details    = {
							eventaddress: center.address,
							centercertnumber:center.certnumber,
							centername:center.name,
							eventcity:address.city,
							eventstate: eventstate,
							eventzipcode:zipcode,
							eventcountry: center.country, 
							norecordsfound:false          
					}
					return { ...state, 
										values: {
															...state.values, 
															...details                   
														},
										fields: {
															...state.fields,
															...details
														}
									}
				}
				else {
					return { ...state, 
						values: {
											...state.values, 
											centers,
											eventcountry: 'usa',
											norecordsfound:false                             
										},
						fields: {
											...state.fields,
											centers,
											eventcountry: 'usa',
											norecordsfound:false   
										}
						}
				}
			}
			else
			{
				return { ...state, 
					values: {
										...state.values, 
										...resetevent, 
										norecordsfound:true                          
									},
					fields: {
										...state.fields,
										...resetevent,
										norecordsfound:true  
									}
					}
			}
		
		}
		case types.FETCH_MEMBER:
		{
			console.log('types.FETCH_MEMBER ',action.payload)
			if(action.payload.request.status === 404)
			{
				return { ...state, 
					values: {
										...state.values,
										...resetdirector,
										norecordsfound:true                          
									},
					fields: {
										...state.fields,
										...resetdirector,
										norecordsfound:true          
									
									}
					}
			}
			else {
			
				const member = action.payload.data.value

			
				const details = {
					directorname:member.firstName + ' ' + member.lastName,
					directorssoemail:member.emailAddress,
					eventemail:state.values.eventemail ? state.values.eventemail : member.emailAddress,
					directorphone:member.eveningPhone,
					directorcountry:member.country,
					directoraddress1:member.address1,
					directoraddress2:member.address2,
					directorcity:member.city,
					directorstate:member.state,
					directorzipcode:member.zip
				}

				//console.log('Member search country',details)
				if(member)
				{
						return { ...state, 
									values: {
														...state.values, 
														...details
													},
									fields: {
														...state.fields,
														...details
													}
								}
				}
				else{
					return state
				}
			}
		}
		case types.FETCH_ACTIVE_SEASONS:
		{
						const seasons = action.payload.data
						let season 
						let eventSeasons 
						
						if ( seasons && state )  {
								
								season = seasons.find(function(season) { return season.isCurrent == true })     
					
								eventSeasons = getEventEligibleSeasons(seasons)

                //This condition was added because there is a scenario where seasons are loaded and there is not a current season.
                if (season) {
                  // get the settings for th default season. This is used for validation purposes
                  const eventSeasonSettings = getEventSeasonSettings(season.id, eventSeasons)

                  return {
                    ...state,
                    values: {
                      ...state.values,
                      seasons: eventSeasons,
                      eventSeasonSettings: eventSeasonSettings,
                      eventseason: season.id.toString()
                    },
                    fields: {
                      ...state.fields,
                      seasons: eventSeasons,
                      eventSeasonSettings: eventSeasonSettings,
                      eventseason: season.id.toString()
                    }
                  }
                }
            }
							return state
		}
    case types.FETCH_ALL_SEASONS:
    {
      const seasons = action.payload.data

      if ( seasons && state )  {
        const season = seasons.find(function(season) { return season.isCurrent })     

        const eventSeasonSettings = getEventSeasonSettings(season.id, seasons)

          return {
            ...state,
            values: {
              ...state.values,
              seasons: seasons,
              eventSeasonSettings: eventSeasonSettings,
              eventseason: season.id.toString()
            },
            fields: {
              ...state.fields,
              seasons: seasons,
              eventSeasonSettings: eventSeasonSettings,
              eventseason: season.id.toString()
            }
          }
      }
      return state
    }
		case types.SEARCHING_SCHOOL:
		{
			return {
				...state, 
				values: 
				{											
					...state.values,
					searching:true,
					schoolNotFound:false
				},
				fields: 
				{
					...state.fields,
					searching:true,
					schoolNotFound:false
				}
			}
		}
		case types.SEARCH_SCHOOLS:
		{
			const {  payload } = action
			const schools = payload.data
			const response = {
				schools,
				searching:false,
				schoolNotFound:schools.length == 0 ? true:false
			}
			return {
				...state, 
				values: 
				{											
					...state.values,
					...response
				},
				fields: 
				{
					...state.fields,
					...response
				}
			}
		}
		case types.RESET_SCHOOLS:
		{
			const schools=[]
			return {
				...state, 
				values: 
				{											
					...state.values,
					schools,
					schoolNotFound:false
				},
				fields: 
				{
					...state.fields,
					schools,
					schoolNotFound:false
				}
			}
		}
		case types.FETCH_SCHOOL:
		{
			const school = action.payload.data
			
			const { eventgendermen,eventgenderwomen , participantschools } = state.values
			const { selectedschool } = state.values
			// this is a temp solutions for issues with &,/ in school name
			console.log('Fetch school', school,selectedschool)
			if(school != undefined)
			{
				school.name = selectedschool
			}
			const participant = addParticipant(school,eventgendermen,eventgenderwomen , participantschools)

			return {
				...state, 
				values: 
				{											
					...state.values,
					schools:[],
					participantschools:[...participant]
				},
				fields: 
				{
					...state.fields,
					schools:[],
					participantschools:[...participant]
				}
			}
		}
		case types.FETCH_NONMEMBER_SCHOOLS:
		{
			const { payload } = action
			const schools = payload.data.Results 
			console.log('event action reducer schools', schools)
			break
		}
		case types.DELETE_SCHOOL:
		{
			const { index } = action.meta
    //  console.log('eventinfo reducer DELETE_SCHOOL case index',index)
			// remove specified index from participant array
			const values = removeSchool(index,state.values)
			const { participantschools } = values
			return { ...state, 
				values: {
									...state.values,
									participantschools
								},
				fields: {
									...state.fields,
									participantschools
								}
				}
		}
		case types.SORT_DESCENDING:
		{
			const values = sortParticipants(types.SORT_DESCENDING,state.values)
			const { participantschools, sorted } = values
			return { 
				...state, 
				values:
				{
					...state.values,
					participantschools,
					sorted
				},
				fields: {
					...state.fields,
					participantschools,
					sorted
				}
			}
		}
		case types.SORT_ASCENDING:
		{
			const values = sortParticipants(types.SORT_ASCENDING,state.values)
			const { participantschools,sorted } = values

			return { 
				...state, 
				values: {
									...state.values,
									participantschools,
									sorted
								},
				fields: {
									...state.fields,
									participantschools,
									sorted
								}
				}
		}
		case types.SAVE_EVENT_INFO:
		{
			if(action.payload.data) {               
				const eventId = action.payload.data              
				return { ...state, 
					values: {
										...state.values,
										eventId:eventId
									},
					fields: {
										...state.fields,
										eventId:eventId
									}
					}
			}
			else {
					return state
			}
		}
		case types.SAVE_EVENT_DETAILS:
		{
			if (action.payload.data) {     
				const eventdetails = setEventDetails(action.payload.data)
				return { ...state, 
					values: {
						...state.values,
						prestineeventdetails:eventdetails,
						eventVerificationEmailSent:true
					},
					fields: {
						...state.fields,
						prestineeventdetails:eventdetails,
						eventVerificationEmailSent:true
					}
				}
			}
			else {
				return state
			}
		}
		case types.SAVE_EVENT_SETUP:
		{
			if (action.payload.data) {     
				const eventsetup = setEventSetup(action.payload.data)
				return { ...state, 
					values: {
						...state.values,
						prestinesetup:eventsetup
					},
					fields: {
						...state.fields,
						prestinesetup:eventsetup
					}
				}
			}
			else {
				return state
			}
		}
		case types.SET_HAS_BRACKETS:
		{ 
			const hasbrackets = action.payload
			return { ...state, 
				values: {
					...state.values,
					hasbrackets
				},
				fields: {
					...state.fields,
					hasbrackets
				}
			}
		}
		case types.SAVE_PARTICIPANT_INFO:
		{   
			const { participantschools }  = state.values 

			return { 
				...state, 
				values: {
					...state.values,
					prestineparticipantschools:[...participantschools],
					savingparticipants:false,
					gettingTeamRosters:false
				},
				fields: {
					...state.fields,
					prestineparticipantschools:[...participantschools],
					savingparticipants:false,
					gettingTeamRosters:false
				}
			}
		}
		case types.SAVING_PARTICIPANT_INFO:
		{  
			const result = {
				gettingTeamRosters:true,
				savingparticipants:true
			}      
			return { 
				...state, 
				values: {
					...state.values,
					...result
				},
				fields: {
					...state.fields,
					...result
				}
			}
		}
		case types.REFRESH_PARTICIPANT_ROSTER:
		{
			const result = {
				gettingTeamRosters:false
			}      
			return { 
				...state, 
				values: {
					...state.values,
					...result
				},
				fields: {
					...state.fields,
					...result
				}
			}
		}
		
		case types.SET_USER_ROLE:
		{  
			
			const result = {
				hasAdminRole:action.payload
			}      
			return { 
				...state, 
				values: {
					...state.values,
					...result
				},
				fields: {
					...state.fields,
					...result
				}
			}
		}
		case types.SET_CORRECT_EVENT_INFO:
		{
			const result = {
				isEventInfoVerified:true
			}      
			return { 
				...state, 
				values: {
					...state.values,
					...result
				},
				fields: {
					...state.fields,
					...result
				}
			}
		}
		case types.SET_CORRECT_EVENT_DETAILS:
		{
			const result = {
				isEventDetailsVerified:true
			}      
			return { 
				...state, 
				values: {
					...state.values,
					...result
				},
				fields: {
					...state.fields,
					...result
				}
			}
		}
		case types.RESEND_DIRECTOR_EMAIL:
		{        
			return { 
				...state, 
				values: {
					...state.values,
					resendingemail:false
				},
				fields: {
					...state.fields,
					resendingemail:false
				}
			}
		}
		case types.SET_WIZARD_STEP:
		{
			const step = action.payload
			return { 
				...state, 
				values: {
					...state.values,
					currentWizardStep:step
				},
				fields: {
					...state.fields,
					currentWizardStep:step
				}
			}
		}
		case types.RESENDING_DIRECTOR_EMAIL:
		{
			return { 
				...state, 
				values: {
					...state.values,
					resendingemail:true
				},
				fields: {
					...state.fields,
					resendingemail:true
				}
			}
		}
		case types.DELETE_EVENT:
		{
			return { ...state, 
				values: 
				{
					...state.values,
					refreshDelete:true
				},
				fields:
				{
					...state.fields,
					refreshDelete:true
				}
			}
		}
		case types.ENABLE_UPLOAD:
		{
			return { ...state, 
				values: 
				{
					...state.values
				},
				fields:
				{
					...state.fields
				}
			}
		}		
		case types.NOTIFY_SCHOOL_NOT_FOUND:
		{
			const notification = {
				notifyingSchoolNotFound:false,
				schoolNotFound:false,
				schoolNotFoundNotfSent:true
			}
			return { ...state, 
				values: {
					...state.values,
					...notification
				},
				fields: {
					...state.fields,
					...notification
				}
			}
		}
		case types.NOTIFY_SCHOOL_NOT_FOUND_KNOWLEDGMENT:
		{
			const notification = {
				notifyingSchoolNotFound:false,
				schoolNotFoundNotfSent:false
			}

			return { ...state, 
				values: {
									...state.values,
									...notification
								},
				fields: {
									...state.fields,
									...notification
								}
				}
		}
		case types.SET_EVENT_SPONSOR:
		{
			const sponsor = action.payload
			let eventgenderwomen
			let eventgendermen
			let eventsamequalifyingformat
			let eventjv
			let eventjvgenderwomen
			let eventjvgendermen
			let eventtier 
			
			if	(sponsor !== sponsors.USBC) {
				eventtier = '2'
			} 
			else {
				eventtier = state.values.eventtier
			}
		
			if (sponsor === sponsors.NCAA) {
				// women only event
				eventgenderwomen = true
				eventgendermen   = false
				eventsamequalifyingformat = "true"
				eventjv = "false"
				eventjvgenderwomen = false
				eventjvgendermen = false

				return { 
					...state, 
					values: {
						...state.values,
						eventgenderwomen,
						eventgendermen,
						eventsamequalifyingformat,
						eventjv,
						eventjvgenderwomen,
						eventjvgendermen,
						eventtier
					},
					fields: {
						...state.fields,
						eventgenderwomen,
						eventgendermen,
						eventsamequalifyingformat,
						eventjv,
						eventjvgenderwomen,
						eventjvgendermen,
						eventtier
					}
				}
			}
			else
			{
				eventgenderwomen = true
				eventgendermen   = true
				eventjv = "true"
				eventjvgenderwomen = true
				eventjvgendermen = true
				return { 
					...state, 
					values: {
						...state.values,
						eventgenderwomen,
						eventgendermen,
						eventjv,
						eventjvgenderwomen,
						eventjvgendermen,
						eventtier
					},
					fields: {
						...state.fields,
						eventgenderwomen,
						eventgendermen,
						eventjv,
						eventjvgenderwomen,
						eventjvgendermen,
						eventtier
					}
				}
			}
		}
		case types.SET_CERTIFICATION_NUMBER:
		{
			const { certificationNumber, forceCertificationNumber }  = action.payload
			return { 
				...state, 
				values: {
					...state.values,
					certificationNumber,
					forceCertificationNumber
				
				},
				fields: {
					...state.fields,
					certificationNumber,
					forceCertificationNumber
				}
			}
		}
		case types.SET_SELECTED_SCHOOL:
		{
			const selectedschool = action.payload
			return { 
				...state, 
				values: {
					...state.values,
					selectedschool
				
				},
				fields: {
					...state.fields,
					selectedschool
				}
			}
		}
		case types.SAVE_EVENT_CERT_NUMBER:
		{
			const { eventcertnumber } = state.values
			return { 
				...state, 
				values: {
					...state.values,
					prestineeventcertnumber:eventcertnumber
				
				},
				fields: {
					...state.fields,
					prestineeventcertnumber:eventcertnumber
				}
			}
		}
		case types.GETTING_PARTICIPANT_ROSTER:
		{
			const result = {
				gettingTeamRosters:true
			}
			return { ...state, 
				values: 
				{
					...state.values,
					...result
				},
				fields:
				{
					...state.fields,
					...result
				}
			}
		}
		case types.SET_EVENT_JV:
		{
			const { payload } = action
			const { hasJV }  = payload 
			//const { eventjvgendermen,eventjvgenderwomen } = state.values
			console.log('Reducer SET_EVENT_JV state, hasJV',hasJV ,typeof(hasJV))

			const result = {
				eventjv:hasJV ? "true":"false",
				eventjvgendermen: hasJV,
				eventjvgenderwomen: hasJV,
				updatejvevent: true
			/* 	eventjvgendermen: hasJV === false ? false:eventjvgendermen,
				eventjvgenderwomen: hasJV === false ? false:eventjvgenderwomen, */
			}   
			//console.log('eventinfo reducer, types.SET_EVENT_JV', hasJV,result)
			return { 
				...state, 
				values: 
				{
					...state.values,
					...result
				},
				fields:
				{
					...state.fields,
					...result
				}
			}
		}
		case types.UPDATE_EVENT_JV:
		{
			const result = {
				updatejvevent: false
			}
			return { 
				...state, 
				values: 
				{
					...state.values,
					...result
				},
				fields:
				{
					...state.fields,
					...result
				}
			}
		}
		case types.fileUpload.SET_EVENT_RESULTS_FILENAME:
		{
			const eventResultsFileName = action.payload
			
			return { ...state, 
				values: 
				{
					...state.values,
					eventResultsFileName
				},
				fields:
				{
					...state.fields,
					eventResultsFileName
				}
			}
		}
		case types.fileUpload.RESET_EVENT_RESULTS_FILE:
		{
		
			const reset = {
				savingdata:false,
				datasaved:false,
				eventresults:{},
				eventResultsFileName:'',
				uploadingResultsFile:false,
				wrongFileUploadType:false,
				uploadErrorMessage:'',
				successfulUpload:false
			}
			return  { 
				...state, 
				values: 
				{
					...state.values,
					...reset    
				},
				fields: 
				{
					...state.fields,
					...reset       
				}
			}
		}
		case types.fileUpload.UPLOADING_RESULTS_FILE:
		{
			const uploadingfile = true
			return  { 
				...state, 
				values: 
				{
					...state.values,
					uploadingfile  
				},
				fields: 
				{
					...state.fields,
					uploadingfile      
				}
			}
		}
		case types.fileUpload.UPLOAD_EVENT_RESULTS:
		{
			let uploadErrorMessage = ''
			const { response }     = action.payload


			if( response != undefined)
			{
				const responseStatus   = response.status

				if( responseStatus == 400 )
				{
					uploadErrorMessage = response.data
				}
			}
			
			const uploadingfile = false
		
			const successfulUpload = (uploadErrorMessage == '' ) ? true: false
			
			return  { 
				...state, 
				values: 
				{
					...state.values,
					uploadingfile,
					uploadErrorMessage ,
					successfulUpload 
				},
				fields: 
				{
					...state.fields,
					uploadingfile,
					uploadErrorMessage ,
					successfulUpload     
				}
			}
		}
		case types.fileUpload.WRONG_FILE_UPLOAD_TYPE:
		{
			const wrongFileUploadType = true
			return  { 
				...state, 
				values: 
				{
					...state.values,
					wrongFileUploadType  
				},
				fields: 
				{
					...state.fields,
					wrongFileUploadType      
				}
			}
		}
		case types.fileUpload.RESET_UPLOAD_ERROR_MESSAGE:
		{
			const uploadErrorMessage = ''
			const successfulUpload = false
			return  { 
				...state, 
				values: 
				{
					...state.values,
					uploadErrorMessage,
					successfulUpload 
				},
				fields: 
				{
					...state.fields,
					uploadErrorMessage,
					successfulUpload      
				}
			}
		}
		default:
			return state    
	}
}



// WEBPACK FOOTER //
// ./src/redux/reducers/forms/eventinfo.js